module.exports = __webpack_public_path__ + "static/media/Win.93935b2d.png";